export const SUBSCRIPTION_FEATURE_CODE = Object.freeze({
  EINVOICES: "ERAC",
  INVOICES: "RAC",
  SERVICES: "USL",
  TICKETING: "TIK",
  FORMS: "OBR",
  FORMS_PDF: "OBR-PDF",
  EVENT: "EVT",
  AI_ASSISTENT: "ASS",
  AI_CMS: "AICMS",
  CONTENT_LECTURE: "AILEC",
  CONTENT_CREATE: "AICC",
  CONTENT_TRANSLATE: "AITRA",
  HELPDESK_ASSISTANT: "AIHDA",
  AI_CHAT: "AICH",
  PROMO: "PROMO",
  IOT_SMART_AGRICULTURE: "ISA",
  LOYALTY: "LOY",
});
